import React, { useMemo } from "react";

import get from "lodash/get";
import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import Chip from "shared/components/Chip";
import Spin from "shared/components/Spin";
import { MOBILE_MAX_WIDTH } from "utils/constants";
import useWindowDimensions from "utils/hooks/useWindowDimensions";

import "./styles.scss";

const Component = ({ query, selected, onSelect }) => {
  const { width } = useWindowDimensions();

  const intervals = useMemo(
    () => get(query, "data.interventionIntervals.data.intervals", []),
    [query.data],
  );

  return (
    <>
      {query.loading ? (
        <div className={"interval-loader-container"}>
          <Spin />
        </div>
      ) : (
        <div className={`spaced-row ${width < MOBILE_MAX_WIDTH && "col"}`}>
          {intervals.map(({ start, end }) => (
            <Chip
              key={`inerval:${start}-${end}`}
              text={`${moment(start, "HH:mm:ss.SSS").format("HH")}H - ${moment(
                end,
                "HH:mm:ss.SSS",
              ).format("HH")}H`}
              selected={selected?.start === start && selected?.end === end}
              onClick={() => onSelect({ start, end })}
              animate={true}
              className={"nav-item"}
            />
          ))}
        </div>
      )}
    </>
  );
};

Component.propTypes = {
  query: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      start: PropTypes.string.isRequired,
      end: PropTypes.string.isRequired,
    }).isRequired,
  }),
  selected: PropTypes.shape({
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
  }),
  onSelect: PropTypes.func.isRequired,
};

export default Component;
